import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getPlatformKey = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/platform-key/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Platform key data fetch error:", error);
    throw error;
  }
};

const getPlatformKeybyId = async (id) => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/platform-key/?id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Platform key data fetch error:", error);
    throw error;
  }
};

const editPlatformKey = async (data) => {
  try {
    
    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/platform-key/`,
      data,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );

    return res;
  } catch (e) {
    console.log("Error in Editing Platform Key", e);
    throw e;
  }
};

export {
  getPlatformKey,
  getPlatformKeybyId,
  editPlatformKey,
};
